
<template>
  <base-layout>
    <template v-slot:header>
      <app-header />
    </template>
    <template v-slot:banner>
      <Banner :title="title" />
    </template>
    <template v-slot:default>
      <div class="row">
        <div class="col-md-6">
          <h2>Would you like to be a reseller?</h2>
          <p class="mb-5 mt-5">
            Wholesale sanitizerwristbands for retailers, distributors, and suppliers.
            <a href="mailto:info@sanitizerwristbands.com">Contact  us </a> for more details or schedule a call with us.
          </p>
          <!-- <a href="https://calendly.com/sanitizerwristbands" target="_blank" class="btn main_btn">Schedule a call</a> -->
          <div class="row">
            <div class="col-md-6">
              <a v-on:click="trackCallSchedule" href="https://calendly.com/sanitizerwristbands/15min?back=1" target="_blank" class="btn btn-warning btn-lg">15-MINUTE CALL</a>
            </div>
            <div class="col-md-6">
              <a v-on:click="trackCallSchedule" href="https://calendly.com/sanitizerwristbands/30min?back=1" target="_blank" class="btn btn-info btn-lg">30-MINUTE CALL</a>
            </div>
            <div class="col-md-6" style="margin-top: 24px">
              <a v-on:click="trackCallSchedule" href="https://calendly.com/sanitizerwristbands/60min?back=1" target="_blank" class="btn btn-danger btn-lg">60-MINUTE CALL</a>
            </div>
          </div>
          <div class="row mb-5 mt-5" style="margin-top: 24px">
            <div class="col-md-12">
              <h3>Interested in our bulk rates?</h3>
              <button v-on:click="downloadSellSheet" target="_blank" class="btn main_btn btn-lg">Download Reseller Sell Sheet Now</button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <img src="@/assets/img/cart.jpg" alt="Cart"/>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <app-footer />
    </template>
  </base-layout>
</template>

<script>
/* eslint-disable standard/object-curly-even-spacing */
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import Banner from '@/components/Breadcrumb'
import BaseLayout from '@/layout/BaseLayout'
import AnalyticsMixin from '@/mixins/AnalyticsMixin'

export default {
  components: {
    BaseLayout,
    AppHeader,
    Banner,
    AppFooter
  },
  mixins: [ AnalyticsMixin ],
  data () {
    return {
      title: 'Resell SanitizerWristbands'
    }
  },
  methods: {
    trackCallSchedule (e) {
      window.analytics.track('Scheduled Call', {
        duration: e.target.innerText
      })
    },
    downloadSellSheet () {
      // open swal for email and name
      // this.$swal('Thank you. Your message was sent')
      window.analytics.track('Download Sell Sheet Intent')
      this.$swal({
        title: 'Get a Sneak Peak at our Bulk Pricing Plans',
        text: 'Enter your email address below to download our sell sheet.',
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Email Address',
            type: 'email',
            required: true
          }
        }
      }).then(email => {
        if (email === '') {
          console.log('something empty')
        } else if (email.length > 4) {
          window.analytics.alias(email)
          window.analytics.identify(email, {
            type: 'reseller',
            source: 'sell_sheet_download'
          })
          window.analytics.track('Downloaded Sell Sheet', {
            email: email
          })
          window.location.href = 'https://s3.amazonaws.com/sanitizerwristbands.com/static/sellsheet-v2.pdf'
        }
      })
    }
  },
  mounted () {
    window.analytics.page('Resell')
  },
  metaInfo () {
    return {
      title: 'SanitizerWristbands.com: Become a Reseller today - 50% discount or more on all orders above 100 pieces',
      meta: [
        { name: 'description', content: `Become a Reseller today - 50% discount or more on all orders above 100 pieces`},
        { property: 'og:title', content: `Become a Reseller today - 50% discount or more on all orders above 100 pieces`},
        { property: 'og:site_name', content: 'SanitizerWristbands'},
        { property: 'og:description', content: `Become a Reseller today - 50% discount or more on all orders above 100 pieces`},
        { property: 'og:type', content: 'og:website'},
        { property: 'og:url', content: `https://sanitizerwristbands.com/resell`}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Resell.vue